export const FirestorePaths = {
  SHOPS_COL: "shops",
  SHOP_DOC: "shops/{shop}",
  ARTICLES_COL: "shops/{shop}/articles",
  ARTICLE_DOC: "shops/{shop}/articles/{id}",
  CONFIG_DOC: "shops/{shop}/settings/config",
  NAVIGATION_DOC: "shops/{shop}/settings/navigation",
  APP_SUBSCRIPTION_DOC: "shops/{shop}/app/subscription",
  ANALYTICS: "system/analytics",
  ANALYTICS_SHOPS_COL: "system/analytics/shops",
  ANALYTICS_SHOP_DOC: "system/analytics/shops/{shop}",
};

export type FirestorePaths = typeof FirestorePaths[keyof typeof FirestorePaths];
